import React from 'react';

import {StringIDFolder} from 'constants/FolderConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {NavStoreRegistry} from 'constants/RegistryConstants';
import FileBrowserUtil from 'file-browser/FileBrowserUtil';
// @ts-expect-error
import FileMenu from 'file-browser/FileMenu';
import FinderUtil from 'file-browser/FinderUtil';
import {setDefaultRegistry} from 'registry/DefaultRegistry';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import ExpandedScrollableTable from 'ui-library/scrollable/ExpandedScrollableTable';
import {ScrollableTableRow} from 'ui-library/scrollable/ScrollableTableConstants';
import * as DateUtil from 'util/DateUtil';
import {BasicEvent} from 'util/Types';

interface ExpandedRegistryTableRow extends ScrollableTableRow {
  extra: {
    result: NavStoreRegistry;
    rootFolder: StringIDFolder;
  };
}

export interface ExpandedRegistryTableProps {
  className?: string;
  finderId: string;
  openResult: (rootFolder: StringIDFolder) => void;
  registries: Array<NavStoreRegistry>;
  areRegistriesLoading: boolean;
}

/**
 * Table for displaying registries.
 */
export default function ExpandedRegistryTable(props: ExpandedRegistryTableProps): JSX.Element {
  const _handleOpenRegistry = (row: ExpandedRegistryTableRow): void => {
    props.openResult(row.extra.rootFolder);
    setDefaultRegistry(row.id);
  };

  const _handleContextMenu = (row: ExpandedRegistryTableRow, e: BasicEvent): void => {
    FileMenu.open(e, {
      file: row.extra.result,
      finderId: props.finderId,
      isListing: true,
    });
  };

  if (props.areRegistriesLoading) {
    return (
      <div>
        <span className="faded">Loading...</span>
      </div>
    );
  } else if (props.registries.length === 0) {
    return (
      <div>
        <span className="faded">None found.</span>
      </div>
    );
  }
  const columns = [
    {
      header: 'Name',
      accessorKey: 'name',
      flexGrow: 1,
      isCollapsible: false,
      isSortable: false,
    },
    {
      header: 'Created',
      accessorKey: 'createdAt',
      isCollapsible: false,
      isSortable: false,
    },
    {
      header: 'Description',
      accessorKey: 'description',
      flexGrow: 1,
      isCollapsible: false,
      isSortable: false,
    },
  ];
  const rows: Array<ExpandedRegistryTableRow> = props.registries.map((registry) => ({
    id: registry.id,
    data: {
      createdAt: DateUtil.readableTime(registry.createdAt, {showTime: false}),
      name: FileBrowserUtil.getRegistryName(registry),
      description: registry.description,
    },
    icon: <BenchlingIcon className="scrollableTable-cell-icon" icon={ModelTypeConstants.REGISTRY} />,
    extra: {
      result: registry,
      rootFolder: FinderUtil.sourceToRootFolder(registry),
    },
  }));
  return (
    <ExpandedScrollableTable
      className={props.className}
      columns={columns}
      isCompact={false}
      matchParentHeight={true}
      onRowClick={_handleOpenRegistry}
      onRowContextMenu={_handleContextMenu}
      rows={rows}
    />
  );
}
